import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../authentication/shared/services/auth.service';
import { LoginType } from '../../../../authentication/shared/services/auth.service';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';
import { AvatarInitialPipe } from '../../pipes/avatar-initial.pipe';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, AvatarInitialPipe],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit, OnDestroy {
  isCollapsed = false;
  showDropdown = false;
  userName = '';
  loginProvider: string = '';
  isManager: boolean = false;
  private userSubscription?: Subscription;

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private socialAuthService: SocialAuthService
  ) {}

  ngOnInit() {
    this.userSubscription = this.userService.getUser().subscribe(
      user => {
        if (user) {
          this.userName = user.name || '';
          this.isManager = true
        }
      }
    );
    this.loginProvider = this.authService.getCurrentLoginProvider();
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: MouseEvent) {
    const profileInfo = document.querySelector('.profile-info');
    const dropdownMenu = document.querySelector('.dropdown-menu');
    
    if (!profileInfo?.contains(event.target as Node) && 
        !dropdownMenu?.contains(event.target as Node)) {
      this.showDropdown = false;
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.showDropdown = !this.showDropdown;
  }

  async logout() {
    const loginType = this.authService.getLoginType();
    
    try {
      switch (loginType) {
        case LoginType.GOOGLE:
          await this.authService.logoutGoogle();
          break;
        case LoginType.MICROSOFT:
          await this.authService.logoutMicrosoft();
          break;
        case LoginType.LINKEDIN:
          break;
      }
      
      this.userService.clearUser();
      localStorage.clear();
      sessionStorage.clear();
      this.socialAuthService?.signOut()
      this.router.navigate(['/signin']);
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/signin']);
    }
  }

  ngOnDestroy() {
    this.userSubscription?.unsubscribe();
  }
}